import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "../../../../components/card/card";
import NormalInput from "../../../../components/form/HorizontalNormalInput";
import Degradation from "./degradation-interactive";
import Opex from "./opex/index";
import Capex from "./capex/index";
import Annualize from "./annualize";
import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import { useParams } from "react-router-dom";
import { matar } from "../../../../api/index.js";
import Swal from "sweetalert2";
import { useReactToPrint } from "react-to-print";
import { downloadExcel } from "../../../../utils/exporter";

function Maintenance({ assetId }) {
  const componentRef = useRef();
  const [open, setOpen] = useState(false);
  const [increase, setIncrease] = useState(false);
  const [decrease, setDecrease] = useState(false);
  const [replacement, setReplacement] = useState(false);
  const [refurbishment, setRefurbishment] = useState(false);
  const [increaseData, setIncreaseData] = useState([]);
  const [decreaseData, setDecreaseData] = useState([]);
  const [replacementData, setReplacementData] = useState([]);
  const [refurbishmentData, setRefurbishmentData] = useState([]);
  const [name, setName] = useState("");
  const [valueRandom, setValueRandom] = useState(0);
  const [showSave, setShowSave] = useState(false);
  const [selectedSimulation, setSelectedSimulation] = useState(null);
  const [year, setYear] = useState("2025");
  const [config, setConfig] = useState(["1"]);
  const [capex, setCapex] = useState("23000");
  const [opex, setOpex] = useState("10000");
  const [strategy, setStrategy] = useState("individual");
  const [listSimulation, setListSimulation] = useState([]);
  const recalculateRandom = () => {
    setValueRandom(valueRandom + 1);
  };
  const [allData, setAllData] = useState([]);
  const downloadHandler = useReactToPrint({
    content: () => componentRef.current,
  });

  const downloadExcelHandler = async () => {
    downloadExcel(allData, "Cost-Simulation");
  };

  const getData = async () => {
    const result = await matar.calculateMatar({
      asset_id: assetId,
    });
    if (result.ok) {
      const body = await result.json();
      const data = body.data.simulation;
      console.log(data);
      setAllData(data);
    }
    getStrategy();
  };

  const getStrategy = async () => {
    const result2 = await matar.getStrategy({
      machine_id: assetId,
    });
    if (result2.ok) {
      const body = await result2.json();
      const data = body.data;
      setListSimulation(data);
    }
  };
  const fixStringToInt = (arr) => {
    const tmp = arr.map((item) => {
      return {
        ...item,
        cost: parseInt(item.cost) || null,
        score: parseFloat(item.score) || null,
        capex: parseInt(item.capex) || null,
        opex: parseInt(item.opex) || null,
        year: parseInt(item.year) || null,
        start: parseInt(item.start) || null,
        duration: parseInt(item.duration) || null,
      };
    });
    //delete null value from the object of array
    const result = tmp.filter((item) => {
      return Object.values(item).some((value) => value !== null);
    });
    return result;
  };
  const simulateData = async () => {
    const result = await matar.calculateMatar({
      asset_id: assetId,
      increase_pm: fixStringToInt(increaseData),
      decrease_pm: fixStringToInt(decreaseData),
      replacement: fixStringToInt(replacementData),
      refurbishment: fixStringToInt(refurbishmentData),
    });
    if (result.ok) {
      const body = await result.json();
      const data = body.data.simulation;
      setAllData(data);
      setShowSave(true);
    }
  };

  const saveSimulation = async () => {
    setOpen(false);
    const result = await matar.saveSimulation({
      name,
      machine_id: assetId,
      param: {
        asset_id: assetId,
        increase_pm: fixStringToInt(increaseData),
        decrease_pm: fixStringToInt(decreaseData),
        replacement: fixStringToInt(replacementData),
        refurbishment: fixStringToInt(refurbishmentData),
      },
    });
    if (result.ok) {
      setShowSave(false);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Strategy saved successfully",
        confirmButtonText: "OK",
      });
    }
    getStrategy();
  };

  const FillDefault = async () => {
    const result = await matar.initiateData({
      asset_id: assetId,
      increase_pm: fixStringToInt(increaseData),
      decrease_pm: fixStringToInt(decreaseData),
      replacement: fixStringToInt(replacementData),
      refurbishment: fixStringToInt(refurbishmentData),
    });
  };

  const updateIncreaseData = (index, data, name) => {
    setIncreaseData((prev) => {
      const newData = [...prev];
      newData[index][name] = data;
      return newData;
    });
  };
  const addIncrease = () => {
    const newData = [...increaseData];
    newData.push({
      cost: 1000,
      pattern: "M",
      start: 2025,
      duration: 5,
    });
    setIncreaseData(newData);
  };
  const removeIncrease = (index) => {
    const newData = [...increaseData];
    newData.splice(index, 1);
    setIncreaseData(newData);
  };

  const updateDecreaseData = (index, data, name) => {
    setDecreaseData((prev) => {
      const newData = [...prev];
      newData[index][name] = data;
      return newData;
    });
  };
  const addDecrease = () => {
    const newData = [...decreaseData];
    newData.push({
      cost: 1000,
      pattern: "M",
      start: 2025,
      duration: 5,
    });
    setDecreaseData(newData);
  };
  const removeDecrease = (index) => {
    const newData = [...decreaseData];
    newData.splice(index, 1);
    setDecreaseData(newData);
  };

  const updateReplacementData = (index, data, name) => {
    setReplacementData((prev) => {
      const newData = [...prev];
      newData[index][name] = data;
      return newData;
    });
  };
  const addReplacement = () => {
    const newData = [...replacementData];
    newData.push({
      capex: 1000,
      year: "2025",
    });
    setReplacementData(newData);
  };
  const removeReplacement = (index) => {
    const newData = [...replacementData];
    newData.splice(index, 1);
    setReplacementData(newData);
  };

  const updateRefurbishmentData = (index, data, name) => {
    setRefurbishmentData((prev) => {
      const newData = [...prev];
      newData[index][name] = data;
      return newData;
    });
  };

  const addRefurbishment = () => {
    const newData = [...refurbishmentData];
    newData.push({
      year: 2026,
      score: 0.7,
      capex: 10000,
      opex: 1000,
    });
    setRefurbishmentData(newData);
  };

  const removeRefurbishment = (index) => {
    const newData = [...refurbishmentData];
    newData.splice(index, 1);
    setRefurbishmentData(newData);
  };

  useEffect(() => {
    if (increase) {
      if (increaseData.length === 0)
        setIncreaseData([
          {
            cost: 1000,
            pattern: "M",
            start: 2025,
            duration: 5,
          },
        ]);
    } else {
      setIncreaseData([]);
    }
    if (decrease) {
      if (decreaseData.length === 0)
        setDecreaseData([
          {
            cost: 1000,
            pattern: "M",
            start: 2025,
            duration: 5,
          },
        ]);
    } else {
      setDecreaseData([]);
    }
    if (replacement) {
      if (replacementData.length === 0)
        setReplacementData([
          {
            capex: 1000,
            year: 2025,
          },
        ]);
    } else {
      setReplacementData([]);
    }
    if (refurbishment) {
      if (refurbishmentData.length === 0)
        setRefurbishmentData([
          {
            year: 2026,
            score: 0.7,
            capex: 10000,
            opex: 1000,
          },
        ]);
    } else {
      setRefurbishmentData([]);
    }
  }, [increase, decrease, replacement, refurbishment]);

  useEffect(() => {
    getData();
  }, [assetId]);
  const deleteConfig = (index) => {
    const newConfig = config.filter((_, i) => i !== index);
    setConfig(newConfig);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const newStrategy = () => {
    setSelectedSimulation(null);
    setName("");
    setIncrease(false);
    setDecrease(false);
    setReplacement(false);
    setRefurbishment(false);
  };

  const changeStrategy = (e) => {
    const fetchByData = async (inc, dec, rep, ref) => {
      const result = await matar.calculateMatar({
        asset_id: assetId,
        increase_pm: fixStringToInt(inc),
        decrease_pm: fixStringToInt(dec),
        replacement: fixStringToInt(rep),
        refurbishment: fixStringToInt(ref),
      });
      if (result.ok) {
        const body = await result.json();
        const data = body.data.simulation;
        setAllData(data);
      }
    };

    const selectedId = e.target.value;
    setSelectedSimulation(selectedId);
    const selectedSimulation = listSimulation.find(
      (item) => item.id === selectedId
    );
    if (selectedSimulation) {
      const prameters = selectedSimulation.parameters;
      setName(selectedSimulation.financialStrategies.name);
      setIncrease(prameters.increase_pm?.length > 0);
      setDecrease(prameters.decrease_pm?.length > 0);
      setReplacement(prameters.replacement?.length > 0);
      setRefurbishment(prameters.refurbishment?.length > 0);
      let inc = [];
      let dec = [];
      let rep = [];
      let ref = [];
      if (prameters.increase_pm?.length > 0) {
        inc = prameters.increase_pm;
        setIncreaseData(prameters.increase_pm);
      } else setIncreaseData([]);
      if (prameters.decrease_pm?.length > 0) {
        dec = prameters.decrease_pm;
        setDecreaseData(prameters.decrease_pm);
      } else setDecreaseData([]);
      if (prameters.replacement?.length > 0) {
        rep = prameters.replacement;
        setReplacementData(prameters.replacement);
      } else setReplacementData([]);
      if (prameters.refurbishment?.length > 0) {
        ref = prameters.refurbishment;
        setRefurbishmentData(prameters.refurbishment);
      } else setRefurbishmentData([]);
      fetchByData(inc, dec, rep, ref);
    } else {
      setName("");
      setIncreaseData([]);
      setDecreaseData([]);
      setReplacementData([]);
      setRefurbishmentData([]);
      getData();
    }
    setShowSave(false);
  };
  return (
    <>
      <div className={"d-flex justify-content-between"}>
        <h2 className="page-header">Financial Strategies</h2>
        <div>
          <button
            className="btn btn-outline-theme btn-sm"
            onClick={downloadExcelHandler}
            style={{ marginRight: "4px" }}
          >
            <i className="fa fa-file-excel"></i> Download Excel
          </button>
          <button
            onClick={downloadHandler}
            className="btn btn-outline-theme btn-sm"
          >
            <i className="fa fa-file-pdf"></i> Download PDF
          </button>
        </div>
      </div>
      <Card className="bg-theme bg-opacity-10 border-theme  mb-3">
        <ConfirmationDlg
          btnSubmitText={"Save"}
          btnCancelText={"Cancel"}
          open={open}
          title={"Save Strategy"}
          onClose={handleClose}
          onSubmit={saveSimulation}
        >
          <h5>Confirm Saving Strategy {name}</h5>
        </ConfirmationDlg>
        <CardBody>
          <div className="row">
            <div className="col-sm-3">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <label>Load Strategy</label>
                  <select
                    value={selectedSimulation}
                    onChange={changeStrategy}
                    className="border-theme form-control text-theme text-center form-control-sm"
                  >
                    <option value="">- AI Prediction -</option>
                    {listSimulation.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item?.financialStrategies?.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-6">
                  <button
                    onClick={newStrategy}
                    className="btn btn-theme text-black btn-sm"
                    style={{ marginTop: "22px" }}
                  >
                    New Strategy
                  </button>
                </div>
              </div>
              <div className={"mb-3"}>
                <b>Opex Strategy</b>
                <div>
                  <div className="form-check form-check-inline">
                    <input
                      value={increase}
                      onChange={(e) => {
                        setIncrease(e.target.checked);
                      }}
                      checked={increase}
                      className="form-check-input"
                      type="checkbox"
                      id="defaultCheck1"
                      style={{ opacity: 1, fontSize: "12px", marginTop: "4px" }}
                    />
                    <label
                      className="form-check-label"
                      style={{ opacity: 1, fontSize: "12px" }}
                      htmlFor="defaultCheck1"
                    >
                      Increase PM
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      value={decrease}
                      onChange={(e) => {
                        setDecrease(e.target.checked);
                      }}
                      checked={decrease}
                      className="form-check-input"
                      type="checkbox"
                      id="defaultCheck2"
                      style={{ opacity: 1, fontSize: "12px", marginTop: "4px" }}
                    />
                    <label
                      className="form-check-label"
                      style={{ opacity: 1, fontSize: "12px" }}
                      htmlFor="defaultCheck2"
                    >
                      Decrease PM
                    </label>
                  </div>
                </div>
              </div>
              <div className={"mb-3"}>
                <b>Capex Strategy</b>
                <div>
                  <div className="form-check form-check-inline">
                    <input
                      value={replacement}
                      onChange={(e) => {
                        setReplacement(e.target.checked);
                      }}
                      checked={replacement}
                      className="form-check-input"
                      type="checkbox"
                      id="Replacement"
                      style={{ opacity: 1, fontSize: "12px", marginTop: "4px" }}
                    />
                    <label
                      className="form-check-label"
                      style={{ opacity: 1, fontSize: "12px" }}
                      htmlFor="Replacement"
                    >
                      Replacement
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      value={refurbishment}
                      onChange={(e) => {
                        setRefurbishment(e.target.checked);
                      }}
                      checked={refurbishment}
                      className="form-check-input"
                      type="checkbox"
                      id="Refrubishment"
                      style={{ opacity: 1, fontSize: "12px", marginTop: "4px" }}
                    />
                    <label
                      className="form-check-label"
                      style={{ opacity: 1, fontSize: "12px" }}
                      htmlFor="Refrubishment"
                    >
                      Refurbishment
                    </label>
                  </div>
                </div>
              </div>
              <NormalInput
                required={true}
                value={name}
                label="Strategy Name"
                placeholder="Strategy Name"
                onchange={(e) => setName(e.target.value)}
              />
              <NormalInput label="Description" placeholder="Description" />
              <hr />
              {increase ? (
                <div>
                  {increaseData.map((item, index) => (
                    <Card className={"mb-3"}>
                      <CardHeader>
                        <div className={"d-flex justify-content-between"}>
                          <div className={"text-theme"}>Increase PM</div>
                          <button
                            className={"btn btn-sm btn-danger"}
                            onClick={() => {
                              removeIncrease(index);
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      </CardHeader>

                      <CardBody>
                        <NormalInput
                          label="Cost Per Event"
                          value={item.cost}
                          onchange={(e) => {
                            updateIncreaseData(index, e.target.value, "cost");
                          }}
                          placeholder="Cost Per Event"
                        />
                        <div className="form-group mb-3">
                          <label
                            className="form-label"
                            htmlFor="exampleFormControlInput1"
                          >
                            Frequency
                          </label>
                          <select
                            className={`form-control`}
                            onChange={(e) => {
                              updateIncreaseData(
                                index,
                                e.target.value,
                                "pattern"
                              );
                            }}
                            value={item.pattern}
                            style={{
                              width: "100%",
                              backgroundColor: "#0000007a",
                            }}
                          >
                            <option value="M">Monthly</option>
                            <option value="3M">Quarterly</option>
                            <option value="6M">Half Yearly (6 Months)</option>
                            <option value="Y">Yearly</option>
                            <option value="2Y">Every 2 Year</option>
                            <option value="3Y">Every 3 Year</option>
                            <option value="4Y">Every 4 Year</option>
                            <option value="5Y">Every 5 Year</option>
                          </select>
                        </div>

                        <div className="row">
                          <div className="col-12">
                            <NormalInput
                              value={item.start}
                              onchange={(e) => {
                                updateIncreaseData(
                                  index,
                                  e.target.value,
                                  "start"
                                );
                              }}
                              label="Year Start"
                              placeholder="eg. 2025"
                            />
                          </div>
                          <div className="col-12">
                            <NormalInput
                              value={item.duration}
                              onchange={(e) => {
                                updateIncreaseData(
                                  index,
                                  e.target.value,
                                  "duration"
                                );
                              }}
                              label="Duration in Year"
                              type={"number"}
                              placeholder="eg. 2"
                            />
                          </div>
                        </div>
                        <hr />
                      </CardBody>
                    </Card>
                  ))}
                  <button
                    className="btn btn-primary btn-sm mb-2"
                    onClick={addIncrease}
                  >
                    Add More Increase PM
                  </button>
                </div>
              ) : null}
              {decrease ? (
                <div>
                  {decreaseData.map((item, index) => (
                    <Card className={"mb-3"}>
                      <CardHeader>
                        <div className={"d-flex justify-content-between"}>
                          <div className={"text-theme"}>Decrease PM</div>
                          <button
                            className={"btn btn-sm btn-danger"}
                            onClick={() => {
                              removeDecrease(index);
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      </CardHeader>

                      <CardBody>
                        <NormalInput
                          label="Cost Per Event"
                          value={item.cost}
                          onchange={(e) => {
                            updateDecreaseData(index, e.target.value, "cost");
                          }}
                          placeholder="Cost Per Event"
                        />
                        <div className="form-group mb-3">
                          <label
                            className="form-label"
                            htmlFor="exampleFormControlInput1"
                          >
                            Frequency
                          </label>
                          <select
                            className={`form-control`}
                            onChange={(e) => {
                              updateDecreaseData(
                                index,
                                e.target.value,
                                "pattern"
                              );
                            }}
                            value={item.pattern}
                            style={{
                              width: "100%",
                              backgroundColor: "#0000007a",
                            }}
                          >
                            <option value="M">Monthly</option>
                            <option value="3M">Quarterly</option>
                            <option value="6M">Half Yearly (6 Months)</option>
                            <option value="Y">Yearly</option>
                            <option value="2Y">Every 2 Year</option>
                            <option value="3Y">Every 3 Year</option>
                            <option value="4Y">Every 4 Year</option>
                            <option value="5Y">Every 5 Year</option>
                          </select>
                        </div>

                        <div className="row">
                          <div className="col-12">
                            <NormalInput
                              value={item.start}
                              onchange={(e) => {
                                updateDecreaseData(
                                  index,
                                  e.target.value,
                                  "start"
                                );
                              }}
                              label="Year Start"
                              placeholder="eg. 2025"
                            />
                          </div>
                          <div className="col-12">
                            <NormalInput
                              value={item.duration}
                              onchange={(e) => {
                                updateDecreaseData(
                                  index,
                                  e.target.value,
                                  "duration"
                                );
                              }}
                              label="Duration in Year"
                              type={"number"}
                              placeholder="eg. 2"
                            />
                          </div>
                        </div>
                        <hr />
                      </CardBody>
                    </Card>
                  ))}

                  <button
                    onClick={addDecrease}
                    className="btn btn-primary btn-sm mb-2"
                  >
                    Add More Decrese PM
                  </button>
                </div>
              ) : null}
              {replacement ? (
                <div>
                  {replacementData.map((item, index) => (
                    <Card className={"mb-3"}>
                      <CardHeader>
                        <div className={"d-flex justify-content-between"}>
                          <div className={"d-flex justify-content-between"}>
                            <div className={"text-theme"}>Replacement</div>
                          </div>
                          <button
                            className={"btn btn-sm btn-danger"}
                            onClick={() => {
                              removeReplacement(index);
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      </CardHeader>
                      <CardBody>
                        <NormalInput
                          value={item.capex}
                          onchange={(e) => {
                            updateReplacementData(
                              index,
                              e.target.value,
                              "capex"
                            );
                          }}
                          label="Cost Per Event"
                          placeholder="Cost Per Event"
                        />

                        <NormalInput
                          value={item.year}
                          onchange={(e) => {
                            updateReplacementData(
                              index,
                              e.target.value,
                              "year"
                            );
                          }}
                          label="Year duration"
                          placeholder="eg. 2025"
                        />
                      </CardBody>
                    </Card>
                  ))}
                </div>
              ) : null}
              {refurbishment ? (
                <div>
                  {refurbishmentData.map((item, index) => (
                    <Card className={"mb-3"}>
                      <CardHeader>
                        <div className={"d-flex justify-content-between"}>
                          <div className={"text-theme"}>Refurbishment</div>
                          <button
                            className={"btn btn-sm btn-danger"}
                            onClick={() => {
                              removeRefurbishment(index);
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      </CardHeader>
                      <CardBody>
                        <NormalInput
                          value={item.capex}
                          onchange={(e) => {
                            updateRefurbishmentData(
                              index,
                              e.target.value,
                              "capex"
                            );
                          }}
                          label="Capex Cost"
                          placeholder="Capex Cost"
                        />

                        <NormalInput
                          value={item.opex}
                          onchange={(e) => {
                            updateRefurbishmentData(
                              index,
                              e.target.value,
                              "opex"
                            );
                          }}
                          label="Opex Cost"
                          placeholder="Opex Cost"
                        />
                        <NormalInput
                          value={item.score}
                          onchange={(e) => {
                            updateRefurbishmentData(
                              index,
                              e.target.value,
                              "score"
                            );
                          }}
                          label="Post Rehabilitation Deterioration Score"
                          placeholder="eg 0.7"
                        />

                        <NormalInput
                          value={item.year}
                          onchange={(e) => {
                            updateRefurbishmentData(
                              index,
                              e.target.value,
                              "year"
                            );
                          }}
                          label="Year"
                          placeholder="eg. 2025"
                        />
                      </CardBody>
                    </Card>
                  ))}

                  <button
                    onClick={addRefurbishment}
                    className="btn btn-primary btn-sm mb-2"
                  >
                    Add More Refurbish Config
                  </button>
                </div>
              ) : null}

              <br />
              {/*{config.map((item, index) => (*/}
              {/*  <Card className={"mb-3"}>*/}
              {/*    <CardHeader>*/}
              {/*      <div className={"d-flex justify-content-between"}>*/}
              {/*        <div className={"text-theme"}>Preventive Config</div>*/}
              {/*        <button*/}
              {/*          className={"btn btn-sm btn-danger"}*/}
              {/*          onClick={() => {*/}
              {/*            deleteConfig(index);*/}
              {/*          }}*/}
              {/*        >*/}
              {/*          <i class="fa fa-trash"></i>*/}
              {/*        </button>*/}
              {/*      </div>*/}
              {/*    </CardHeader>*/}
              {/*    <CardBody>*/}
              {/*      <NormalInput*/}
              {/*        label="Cost Per Event"*/}
              {/*        placeholder="Cost Per Event"*/}
              {/*      />*/}
              {/*      <div className="form-group mb-3">*/}
              {/*        <label*/}
              {/*          className="form-label"*/}
              {/*          htmlFor="exampleFormControlInput1"*/}
              {/*        >*/}
              {/*          Frequency*/}
              {/*        </label>*/}
              {/*        <select*/}
              {/*          className={`form-control`}*/}
              {/*          style={{ width: "100%", backgroundColor: "#0000007a" }}*/}
              {/*        >*/}
              {/*          <option value="Monthly">Monthly</option>*/}
              {/*          <option value="Weekly">Weekly</option>*/}
              {/*          <option value="Yearly">Yearly</option>*/}
              {/*        </select>*/}
              {/*      </div>*/}

              {/*      <NormalInput*/}
              {/*        label="Year duration"*/}
              {/*        placeholder="eg. 2025-2027"*/}
              {/*      />*/}
              {/*    </CardBody>*/}
              {/*  </Card>*/}
              {/*))}*/}
              {/*<button*/}
              {/*  className="btn btn-primary btn-sm"*/}
              {/*  onClick={() => {*/}
              {/*    setConfig([...config, "1"]);*/}
              {/*  }}*/}
              {/*>*/}
              {/*  Add Preventive Config*/}
              {/*</button>*/}
              <hr />
              <div className="d-flex justify-content-end">
                {/*<button*/}
                {/*  className="btn btn-outline-theme"*/}
                {/*  style={{ marginRight: "10px" }}*/}
                {/*  onClick={FillDefault}*/}
                {/*>*/}
                {/*  <i className="fa fa-chart-area"></i> FillDefault*/}
                {/*</button>*/}
                {showSave ? (
                  <button
                    style={{ marginRight: "10px" }}
                    className="btn btn-outline-theme"
                    onClick={() => {
                      if (name === "") {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Please fill the strategy name",
                        });
                        return;
                      }
                      setOpen(true);
                    }}
                  >
                    <i className="fa fa-floppy-disk"></i> Save
                  </button>
                ) : null}
                <button
                  className="btn btn-outline-theme"
                  onClick={simulateData}
                >
                  <i className="fa fa-chart-area"></i> Simulate
                </button>
              </div>
            </div>
            <div className="col-sm-9 " ref={componentRef}>
              <div className={"print-header"}>
                <img
                  src="/img/hamad_header.png"
                  style={{ height: "80px" }}
                  alt=""
                />
              </div>
              <div className={"content matar"}>
                <Degradation
                  recalculateRandom={valueRandom}
                  referenceLines={{
                    increaseData,
                    decreaseData,
                    replacementData,
                    refurbishmentData,
                  }}
                  allData={allData}
                />
                <div className={"page-break"}>
                  <div className="content">
                    <Capex changedValue={valueRandom} allData={allData} />
                    <Opex changedValue={valueRandom} allData={allData} />
                  </div>
                </div>
                <div className={"page-break"}>
                  <div className="content">
                    <Annualize changedValue={valueRandom} allData={allData}>
                      {" "}
                    </Annualize>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                {showSave ? (
                  <button
                    className="btn btn-outline-theme"
                    onClick={() => {
                      if (name === "") {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Please fill the strategy name",
                        });
                        return;
                      }
                      setOpen(true);
                    }}
                  >
                    <i className="fa fa-floppy-disk"></i> Save
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
}

export default Maintenance;
